import { useEffect, useState, useRef } from "react";
import useJobExecutor from "../../useJobExecutor";
import useCounterRef from "../Utils/useCounterRef";

const useRemoteDataFetcher = (props) => {
  const {
    isContentLoaded = false,
    dependencies = [],
    fetchCondition = () => true,
    remoteOptions = {},
    fetchOnlyOnce = false,
    remoteDataReader,
    remoteDataWriter,
    waitForAll = false
  } = props;

  const {
    getCurrentCount: getCurrentRequestsCount,
    incrementCounter: incrementRequestsCounter,
    decrementCounter: decrementRequestsCounter
  } = useCounterRef();

  const actionsBeforeContentLoad = () => {
    incrementRequestsCounter();
    setContentLoaded(false);
  }

  const actionsAfterContentLoad = () => {
    decrementRequestsCounter();
    if(waitForAll) {
      getCurrentRequestsCount() === 0 && setContentLoaded(true);
    } else {
      setContentLoaded(true);
    }
  }

  const [remoteData, setRemoteData] = (() => {
    if (!!remoteDataReader || !!remoteDataWriter) {
      return [remoteDataReader, remoteDataWriter];
    } else {
      return useState({});
    }
  })();
  const [fetchedOnce, setFetchedOnce] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(isContentLoaded);
  const remoteDataFetcher = useJobExecutor(remoteOptions.url);

  const shouldFetchData = () => {
    return (fetchOnlyOnce ? !fetchedOnce : true) && fetchCondition();
  };

  useEffect(() => {
    if (shouldFetchData()) {
      actionsBeforeContentLoad();
      remoteDataFetcher(remoteOptions.urlOptions)
        .then((response) => setRemoteData(response.data))
        .then(() => {
          actionsAfterContentLoad();
          fetchOnlyOnce && setFetchedOnce(true);
        });
    }
  }, dependencies);

  return { remoteData, setRemoteData, contentLoaded, setContentLoaded };
};

export default useRemoteDataFetcher;
